<template>
  <div class="content">
    <router-view />
  </div>

  <div class="bottom-nav">
    <!-- 首页 -->
    <router-link to="/home" class="nav-item" active-class="active">
      <svg class="nav-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M3 10.5L12 3l9 7.5V19a2 2 0 01-2 2H5a2 2 0 01-2-2v-8.5z"
              stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M9 21V12.5a1 1 0 011-1h4a1 1 0 011 1V21"
              stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
        <path class="icon-accent" d="M14 3.5C13 5 14.5 8 17 6.5c0 1.5-1 2.5-1 2.5s2-.3 3-1.5"
              stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" opacity="0.6"/>
      </svg>
      <span class="text">首页</span>
    </router-link>

    <!-- 设备 -->
    <router-link to="/device" class="nav-item" active-class="active">
      <svg class="nav-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="4" y="4" width="16" height="13" rx="2.5"
              stroke="currentColor" stroke-width="1.8"/>
        <rect x="7" y="7" width="10" height="6" rx="1"
              stroke="currentColor" stroke-width="1.5" stroke-dasharray="2 1.5" opacity="0.5"/>
        <line x1="12" y1="17" x2="12" y2="20"
              stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>
        <path class="icon-accent" d="M4 4.5C6 3 7 4 8 2.5"
              stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" opacity="0.6"/>
      </svg>
      <span class="text">设备</span>
    </router-link>

    <!-- 社区 -->
    <router-link to="/community" class="nav-item" active-class="active">
      <svg class="nav-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="9" cy="7.5" r="2.5" stroke="currentColor" stroke-width="1.8"/>
        <circle cx="15" cy="7.5" r="2.5" stroke="currentColor" stroke-width="1.8"/>
        <path d="M3.5 20c0-3.04 2.46-5.5 5.5-5.5s5.5 2.46 5.5 5.5"
              stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>
        <path d="M9.5 20c0-3.04 2.46-5.5 5.5-5.5s5.5 2.46 5.5 5.5"
              stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>
        <path class="icon-accent" d="M12 13.5c0.5-1 2-1.5 3-1"
              stroke="currentColor" stroke-width="1.5" stroke-linecap="round" opacity="0.6"/>
      </svg>
      <span class="text">社区</span>
    </router-link>

    <!-- 我的 -->
    <router-link to="/mine" class="nav-item" active-class="active">
      <svg class="nav-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="12" cy="8" r="4" stroke="currentColor" stroke-width="1.8"/>
        <path d="M4 21c0-4.42 3.58-8 8-8s8 3.58 8 8"
              stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>
        <path class="icon-accent" d="M8.5 3.5C9.5 2.5 11 3 12 1.5c1 1.5 2.5 1 3.5 2"
              stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" opacity="0.6"/>
      </svg>
      <span class="text">我的</span>
    </router-link>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
#app {
  font-family: 'PingFang SC', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2C2C2A;
}
.content {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 56px;
  overflow: auto;
  background: #f5f4f0;
}
.bottom-nav {
  display: flex;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  height: 56px;
  background: #fff;
  box-shadow: 0 -2px 16px rgba(15, 110, 86, 0.08);
  z-index: 1000;
  padding-bottom: env(safe-area-inset-bottom, 0);
}

.nav-item {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #888780;
  text-decoration: none;
  font-size: 11px;
  transition: color 0.25s ease;
  -webkit-tap-highlight-color: transparent;
}

.nav-item.active {
  color: #0F6E56;
}

.nav-icon {
  width: 24px;
  height: 24px;
  margin-bottom: 2px;
  transition: transform 0.25s ease;
}

.nav-item.active .nav-icon {
  transform: scale(1.1);
}

.nav-item.active .icon-accent {
  opacity: 1;
}

.text {
  font-size: 11px;
  font-weight: 500;
  letter-spacing: 0.3px;
}

/* 适配手机端 */
@media (max-width: 768px) {
  .bottom-nav {
    height: 64px;
  }

  .nav-icon {
    width: 26px;
    height: 26px;
  }

  .text {
    font-size: 12px;
  }
}
</style>